export default function FooterDatalayerLink({to, text, item}) {
  const handleFooterDataLayerOnClick = (evt) => {
    evt.preventDefault();
    const {target} = evt;
    dataLayer.push({
      event: 'footer_options',
      menu: evt.target.innerHTML,
    });
    window.location.href = target.href;
  };

  return (
    <>
      {item.type != 'Resource' ? (
        <a href={to} onClick={(evt) => handleFooterDataLayerOnClick(evt)}>
          {text}
        </a>
      ) : (
        <a
          href={item.resource.asset.url}
          download="download"
          target="_blank"
          rel="noreferrer"
        >
          {text}
        </a>
      )}
    </>
  );
}
